/**
 * digitsSum — Suma de dígitos
 *
 * Recibe un entero positivo y devuelve la suma de todos sus dígitos.
 * Utiliza aritmética pura con % y Math.floor sin convertir a string.
 *
 * @param {number} inputInt - Entero positivo
 * @returns {number} Suma de los dígitos
 *
 * @example
 * digitsSum(12345) // → 15  (1+2+3+4+5)
 * digitsSum(999)   // → 27  (9+9+9)
 */
export function digitsSum(inputInt) {
  let sum = 0;

  // % 10 extrae el último dígito: 12345 % 10 = 5
  // Math.floor elimina ese dígito: Math.floor(12345/10) = 1234
  // El bucle repite hasta consumir todos los dígitos
  while (inputInt > 0) {
    sum += inputInt % 10;
    inputInt = Math.floor(inputInt / 10);
  }

  return sum;
}

/** Casos de prueba oficiales del ejercicio */
export const TEST_CASES = [
  { input: 999,     expected: 27 },
  { input: 9184501, expected: 28 },
  { input: 12345,   expected: 15 },
];
